

export const usernameValidation = (TextField) => {
    if (TextField.length >= 3) {
        return true
    }
    return false
}

export const nameValidation = (TextField) => {
    if (/^(?!\s*$).+/.test(TextField)) {
        return true
    }
    return false
}

export const surnameValidation = (TextField) => {
    if (/^(?!\s*$).+/.test(TextField)) {
        return true
    }
    return false
}

export const emailValidation = (TextField) => {
    if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(TextField)) {
        return true
    }
    return false
}

export const emailEmptyValidation = (TextField) => {
    if (/^(?!\s*$).+/.test(TextField)) {
        return true
    }
    return false
}

export const numberValidation = (TextField) => {
    if (/^\+(?:[0-9]●?){6,14}[0-9]$/.test(TextField)) {
        return true
    }
    return false
}

export const numberEmptyValidation = (TextField) => {
    if (/^(?!\s*$).+/.test(TextField)) {
        return true
    }
    return false
}

export const passLenghtValidation = (TextField) => {
    if (TextField.length >= 6) {
        return true
    }
    return false
}

export const onlyNumbersValidation = (TextField) => {
    if (/^[0-9]*$/.test(TextField)) {
        return true
    }
    return false
}


export const Validate = (info, tag = '') => {
    try {
        if (tag == undefined) {
            throw true
        }

        if (tag == "number")
            if (!onlyNumbersValidation(info)) {
                throw false
            }

        if (tag == 'username')
            if (!usernameValidation(info)) {
                throw false
            }
        if (tag == 'name')
            if (!nameValidation(info)) {
                throw false
            }
        if (tag == 'surname')
            if (!surnameValidation(info)) {
                throw false
            }
        if (tag == 'numberValidation')
            if (!numberEmptyValidation(info)) {
                throw false
            }
        if (tag == "numberValidation")
            if (!numberValidation(info)) {
                throw false

            }
        if (tag == 'email')
            if (!emailEmptyValidation(info)) {
                throw false

            }
        if (tag == 'email')
            if (!emailValidation(info)) {
                throw false
            }
        if (tag == 'password')
            if (info && !passLenghtValidation(info)) {
                throw false
            }
        if (tag == 'password1')
            if (!passLenghtValidation(info)) {
                throw false
            }

        if (tag == 'username')
            if (!usernameValidation(info)) {
                throw false
            }

        // alert("atnaujinta")
        return true
    }
    catch (e) { console.log(e) }
}